module.exports = __webpack_public_path__ + "static/media/admin-tag-icon.40bbccf2.svg";